import { Bookmark, Filter, Trash2 } from "lucide-react";
import React, { useState, useRef, useEffect } from "react";
import DeleteModal from "../Modal/DeleteModal";
import { notify } from "../../helpers";
import { deleteFilterHistory } from "../../services/saveFilter";
import Spacing from "../Spacing";
import { Drawer } from 'vaul';

export default function SaveFilter({
  account_id,
  location_id,
  user_id,
  filterData = [],
  setDataLoading = () => {},
  setPatientFormData = () => {},
  setSelectedInsuranceOptions = () => {},
  handleFilterCheckboxChange = () => {},
  setSelectedMeasures = () => {},
  setFilter = () => {},
  setShowSave = () => {},
  loadFilters = () => {},
  reloadData = () => {},
  reloadDataFilter = {},
  previousScrollPosition = 0,
  setPreviousScrollPosition = () => {}
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [deleteRecord, setDeleteRecord] = useState({});
  const [activeDeleteModal, setActiveDeleteModal] = useState(false);
  const dropdownRef = useRef(null);
  const [drawerPosition, setDrawerPosition] = useState({ top: 0, right: 0 });

  const toggleDropdown = () => {
    const triggerElement = document.querySelector('.docpro_filter');
    if (triggerElement) {
      const rect = triggerElement.getBoundingClientRect();
      setDrawerPosition({
        top: rect.bottom + window.scrollY,
        right: window.innerWidth - rect.right,
      });
    }
    setIsOpen(!isOpen);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  };

  const handleOutsideClick = (event) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target)
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  const handleDeleteRecord = async (id) => {
    setDataLoading(true);
    try {
      const result = await deleteFilterHistory(
        account_id,
        location_id,
        user_id,
        id,
      );
      if (result.detail) {
        notify("error", result.detail, 2);
      } else {
        if(result?.data?.status === "success") {
          reloadData(reloadDataFilter);
          loadFilters();
          setFilter(reloadDataFilter);
          notify("success", result?.data?.message, 2);
        } else {
          notify("error", result?.data?.message, 2);
        }
      }
    } catch (error) {
      // console.log("🚀 ~ handleDeleteRecord ~ error:", error);
    }
  };
  
  const getFilterData = async (data) => {
    data.account_id = account_id;
    data.location_id = location_id;
    data.page = 1;

    setDataLoading(true);
    setPatientFormData(data);
    setSelectedInsuranceOptions(data?.insurance_ids);
    handleFilterCheckboxChange(data?.patient_type);
    setSelectedMeasures(data?.quality_measure);
    setFilter(data);
    setShowSave(false);
    setIsOpen(!isOpen);
  };

  const LimitText = ({ text, limit }) => {
    if (text?.length <= limit) {
      return text;
    } else {
      const limitText = text?.substring(0, limit) + "...";
      return limitText;
    }
  };

  const handleDrawerClose = () => {
    setIsOpen(false);
    window.scrollTo(0, previousScrollPosition);
  };

  return (
    <>
      <div className="small_device" style={{ position: "relative" }} ref={dropdownRef}>
        <Drawer.Root open={isOpen} onOpenChange={setIsOpen} onClose={handleDrawerClose}>
          <Drawer.Trigger
            className="docpro_filter docpro_fw_500"
            onClick={() => toggleDropdown()}
          >
            <Bookmark width={16} height={16} />
            <span className="filter_save_text">Saved <span className="xs_display">filters</span></span>
          </Drawer.Trigger>
  
          <Drawer.Portal>
            <Drawer.Overlay className="docpro_drawer_overlay"/>
            <Drawer.Content
              className="docpro_drawer_content docpro_drawer_style_6"
              style={{
                top: drawerPosition.top,
                right: drawerPosition.right,
                position: 'absolute',
              }}
            >
              <Drawer.Title className="sr-only">Filter Data</Drawer.Title>
              <Drawer.Description className="sr-only">A menu for the user to filter data table.</Drawer.Description>
              <div className="docpro_filter_dropdown_body filter_summery">
                <h4 className="docpro_fs_16 docpro_mb_0"><Filter width={17} height={17} /> Saved Filters</h4>
                <Spacing lg="8" sm="8" />
                {filterData?.map((item, index) => (
                  <li
                    key={index}
                    className="filter_options"
                  >
                    <div 
                      className="w-full pointer"
                      onClick={() => getFilterData(item?.filter_data)}
                    >
                      <span className="docpro_mb_0 pointer docpro_icon_btn last_btn_tip overview" style={{ width: 'auto', height: 'auto', color: 'var(--primary)', display: 'block' }}>
                        <LimitText text={item?.filter_title} limit={20} />
                        <div className="docpro_tip" style={{ maxWidth: '300px', minWidth: '100px', whiteSpace: 'pre-wrap' }}>
                          <span>{item?.filter_title}</span>
                        </div>
                      </span>
                    </div>
                    <button
                      type="button"
                      className="docpro_icon_btn docpro_icon_btn_red last_btn_tip"
                      onClick={() => {
                        setDeleteRecord(item);
                        setActiveDeleteModal(true);
                        setPreviousScrollPosition(window.scrollY);
                        window.scrollTo(0, 0);
                      }}
                    >
                      <Trash2 width={17} height={17} />
                      <span className="docpro_tip">Delete</span>
                    </button>
                  </li>
                ))}
              </div>
            </Drawer.Content>
          </Drawer.Portal>
        </Drawer.Root>
      </div>

      {activeDeleteModal && (
        <DeleteModal
          handleDelete={() => handleDeleteRecord(deleteRecord?.id)}
          name={deleteRecord?.filter_title ? deleteRecord?.filter_title : "this filter"}
          activeModal={activeDeleteModal}
          setActiveModal={setActiveDeleteModal}
          previousScrollPosition={previousScrollPosition}
          setPreviousScrollPosition={setPreviousScrollPosition}
        />
      )}
    </>
  );
}
